import { createSlice } from "@reduxjs/toolkit";

// Create a slice
const PaySlice = createSlice({
  name: "pay",
  initialState: {
    data: null,
    status: false,
    error: null,
  },
  reducers: {
    PayStart: (state) => {
      state.status = true;
    },
    PaySuccess: (state, action) => {
      state.status = false;
      state.data = action.payload;
    },
    PayFailure: (state, action) => {
      state.status = false;
      state.error = action.payload;
    },
  },
});

export const { PayStart, PaySuccess, PayFailure } = PaySlice.actions;

export default PaySlice.reducer;
